import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'
import { useNavigate } from '@/routing'

import { preview } from '@/components/form/preview'
import { EmailPlan } from './components/EmailPlan'
import { Header } from './components/Header'
import { PlanDetails } from './components/PlanDetails'

import { useCommunicationPlanData } from './hooks/useCommunicationPlanData'
import { useRefreshCommunicationPlanData } from './hooks/useRefreshCommunicationPlanData'

export function CommunicationPlan() {
  // Refresh Communication Plan data every time a user accesses the Communication section
  useRefreshCommunicationPlanData()

  const communicationPlanData = useCommunicationPlanData()
  const userConfig = useSelector(selectUserConfiguration)
  const navigate = useNavigate()

  useEffect(() => {
    if (userConfig.userType === 'gpsOnly' || userConfig.userType === 'rmOnly') {
      navigate('settings')
    }
  }, [navigate, userConfig])

  return (
    <preview.Root
      testId="communication-plan-view"
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={<Header />}
    >
      {communicationPlanData.settings.hasSubscription ? (
        <PlanDetails
          counters={communicationPlanData.counters}
          subscription={communicationPlanData.settings.smsSubscription}
        />
      ) : (
        <EmailPlan counters={communicationPlanData.counters} />
      )}
    </preview.Root>
  )
}
